import { useMemo } from 'react';
import CategoryCard from '../../../components/feature/CategoryCard';
import { categories } from '../../../mocks/categories';
import { allTools } from '../../../mocks/tools';

export default function Categories() {
  // Compute real tool counts dynamically from actual tools data
  const categoriesWithCounts = useMemo(() => {
    return categories.map((cat) => ({
      ...cat,
      toolCount: allTools.filter((t) => t.category === cat.name).length,
    }));
  }, []);

  return (
    <section id="categories" className="py-32 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a] relative">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gray-700/60 to-transparent"></div>
      <div className="max-w-7xl mx-auto">

        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-teal-500/10 border border-teal-500/20 text-teal-400 text-xs font-semibold tracking-widest uppercase mb-5">
            Browse by Category
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5 tracking-tight leading-tight">
            AI Tool Categories
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Explore AI tools organized by use case to find exactly what you need.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categoriesWithCounts.map((category) => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
      </div>
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-gray-700/60 to-transparent"></div>
    </section>
  );
}
